import angularCommonLocalesNlBe from "@angular/common/locales/nl-BE";
import angularCommonLocalesExtraNlBe from "@angular/common/locales/extra/nl-BE";
import angularCommonLocalesNl from "@angular/common/locales/nl";
import angularCommonLocalesExtraNl from "@angular/common/locales/extra/nl";

// global glue variable for externals
if (window["ng"] == null) window["ng"] = <any>{};
if (window["ng"].common == null) window["ng"].common = <any>{};
if (window["ng"].common.locales == null) window["ng"].common.locales = <any>{};
if (window["ng"].common.locales.extra == null)
  window["ng"].common.locales.extra = <any>{};

window["ng"].common.locales.nlBe = angularCommonLocalesNlBe;
window["ng"].common.locales.extra.nlBe = angularCommonLocalesExtraNlBe;

window["ng"].common.locales.nl = angularCommonLocalesNl;
window["ng"].common.locales.extra.nl = angularCommonLocalesExtraNl;

export {
  angularCommonLocalesNlBe,
  angularCommonLocalesExtraNlBe,
  angularCommonLocalesNl,
  angularCommonLocalesExtraNl,
};
